import classNames from 'classnames';

export const getFileUploadClassNames = ({
  className,
  disabled,
}: {
  className?: string;
  disabled?: boolean;
}) => {
  return {
    container: classNames(className, 'file-upload', {
      'cursor-pointer': !disabled,
    }),
    adornmentLabel: classNames(
      'relative inline-flex shrink-0 items-center justify-center whitespace-nowrap font-semibold no-underline',

      disabled
        ? 'text-status-disabled-dark bg-status-disabled'
        : 'text-element-secondary bg-transparent',
    ),
  };
};
